<template>
  <div class="native-row"><slot /></div>
</template>

<style scoped>
.native-row {
  display: grid;
  grid-template-columns: repeat(24, minmax(0, 1fr));
  gap: 20px;
}
</style>
